
/**
 * Convierte una fecha en formato YYYYmmDD (ej: '20250604')
 * @param fechaString string con formato YYYYmmDD
 * @returns string con formato YYYY-MM-DD
 */
export function convertirFechaSQLaInputDate(fechaString: string): string {
  let fecha = '';

  try {
    if (fechaString && fechaString.length === 8) {
      fecha = `${fechaString.substring(0, 4)}-${fechaString.substring(4, 6)}-${fechaString.substring(6, 8)}`;
    }
  } catch (error: any) {
    console.error('ERROR:', error);
  }

  return fecha;
}

export function getLastDayOfCurrentMonth(): string {
  const now = new Date();
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return lastDay.toISOString().split('T')[0];
}
